import { StudioApplication } from 'mappMvcStudio/app';
import { StudioSection } from './studio/studioSection';
import { Templates, Template } from '../compile';
import { ID, Icons } from '../const';

export class Studio extends StudioApplication {
	constructor() {
		super(Templates, Template, {
			ID: ID,
			Icons: Icons,
			Templates: Templates,
			Template: Template
		});
	}

	public newStudioSection(): StudioSection {
		return new StudioSection(this, this.user);
	}

	public getStorageId(): string {
		return 'apps_storage';
	}

	public getClientId(): string {
		return 'App';
	}

	public allowResetPassword(): boolean {
		return true;
	}
}

declare global {
	interface Window {
		studio: Studio;
	}
}

$(document).ready(function(e) {
	window.studio = new Studio();
});
